module.exports = __webpack_public_path__ + "audio/chat/message.wav";